import React, { useEffect } from "react";
import { useStateContext } from "../context/StateContextAPI";
import {
  ContactInformationContainer,
  InfoContainer,
} from "../components/exports/company-info-styles.export";
import { Typography } from "@mui/material";
import useGoogleTag from "../utils/gtag";

const TermsOfUseArtist = () => {
  // GTAG
  const gtag = process.env.REACT_APP_GOOGLE_TAG || "";
  useGoogleTag(gtag);

  const { setActivePage } = useStateContext();

  useEffect(() => {
    setActivePage(() => "");
    window.scrollTo(0, 0);
  }, [setActivePage]);

  return (
    <ContactInformationContainer>
      <div className="rokk-users-faq-sec">
        <div
          className="faq-section-head-text mt-10"
          style={{ textTransform: "uppercase" }}
        >
          Terms and Conditions for the ROKK Affiliate program <br />
          concerning the cooperation in order to acquire users <br />
          for the ROKK music streaming service
        </div>

        <InfoContainer>
          <Typography color="var(--primary)">between</Typography>
          <br />
          <Typography>
            FAIRMUSIC AG
            <br />
            In der Dumpf 12
            <br />
            66130 Saarbrücken
            <br />
            Chairman of the Management Board:
          </Typography>
          <br />
          <Typography color="var(--primary)">and</Typography>
          <br />
          <Typography>
            ARTIST/Manager
            <br />– hereinafter also referred to as “ARTIST” –
          </Typography>
          <br />
          <Typography>
            – COMPANY and ARTIST combined hereinafter also referred to as the
            “Parties” –
          </Typography>
          <br />
          <Typography
            sx={{
              color: "var(--primary)",
              marginBottom: "10px",
              fontSize: "18px",
              fontWeight: "600",
            }}
          >
            Preamble:
          </Typography>

          <Typography>
            FAIRMUSIC operates a music streaming service aimed at improving
            ARTIST’s remuneration. This goal is to be reached via a higher
            payout per stream in combination with direct payments to ARTIST.
            FAIRMUSIC wishes to achieve direct payments to ARTIST by involving
            ARTIST in the marketing and promotion of the www.rokk.app fair
            streaming service, with the mutually beneficial aim of acquiring as
            many users as possible for the streaming service. In return,
            FAIRMUSIC will pay ARTIST a share of monthly sales generated via
            such acquired customers during an agreed term.
          </Typography>
          <br />
          <Typography>
            This being said, the Parties agree on the following:
          </Typography>
          <br />

          <Typography
            sx={{
              color: "var(--primary)",
              marginBottom: "10px",
              fontSize: "18px",
              fontWeight: "600",
            }}
          >
            § 1 Subject matter:
          </Typography>

          <Typography>
            (1) ARTIST will act as a cooperation partner of the COMPANY,
            marketing an Affiliate Link or Voucher Code to be provided to ARTIST
            by the COMPANY.
          </Typography>
          <br />

          <Typography
            sx={{
              color: "var(--primary)",
              margin: "10px 0",
              fontSize: "18px",
              fontWeight: "600",
            }}
          >
            § 2 ARTIST’s obligations:
          </Typography>
          <Typography>
            (1) ARTIST will, taking into account the Parties’ mutual interests,
            promote the Affiliate Link or Voucher Code to the best of their
            ability. On the ARTIST side, this could be, for example, sharing the
            affiliate link regularly on social media, mentioning it in
            interviews or providing certain materials for promo purposes. Such
            materials could be video messages, guitar pages or drum skins or
            even certain contingents of free tickets for concerts that COMPANY
            can raffle off among users.
          </Typography>
          <br />
          <Typography>
            (2) According to the prevailing understanding, the Parties agree
            that such representation is carried out on an avocational basis.
          </Typography>
          <br />

          <Typography
            sx={{
              color: "var(--primary)",
              margin: "10px 0",
              fontSize: "18px",
              fontWeight: "600",
            }}
          >
            § 3 COMPANY’s obligations:
          </Typography>
          <Typography>
            (1) The COMPANY will make their best efforts to support ARTIST in
            carrying out their activities, always providing ARTIST with the
            required details and information.
          </Typography>
          <br />
          <Typography>
            (2) The COMPANY will provide login-protected reports containing
            details on users acquired by ARTIST and registered as users by the
            COMPANY. The COMPANY will provide settlement information at least
            semi-annually. The artist is entitled to a payout as soon as a
            payable amount of EUR 50.00 (in words: fifty Euros) or more has been
            reached. Extra payouts can be agreed on individually. Fairmusic will
            transfer the amount within 2 months.
          </Typography>
          <br />
          <Typography>
            (3) ARTIST will acquire users via the Affiliate Link or Voucher
            Code. If such new users register with and make actual payments for
            music streams to the COMPANY, ARTIST will be entitled to receive
            commission payments by the COMPANY. The Parties agree that the
            decision whether a subscription qualifies in the meaning of below §
            4 of this Agreement lies exclusively with the User and the COMPANY.
          </Typography>
          <br />
          <Typography>
            (4) The COMPANY undertakes to activate (and keep active over the
            entire contractual term to the best of their abilities) the
            Affiliate Link for the ARTIST. This being said, ARTIST has no claims
            towards the COMPANY regarding uninterrupted access to an active
            Affiliate Link.
          </Typography>
          <br />

          <Typography
            sx={{
              color: "var(--primary)",
              margin: "10px 0",
              fontSize: "18px",
              fontWeight: "600",
            }}
          >
            § 4 Commissionable transactions:
          </Typography>
          <Typography>
            (1) ARTIST is entitled to receive commission payments for every new
            User brokered to the COMPANY via the Affiliate Link as soon as such
            new User closes a chargeable transaction with the COMPANY concerning
            the use of the streaming service. The COMPANY will not make advance
            payments.
          </Typography>
          <br />

          <Typography
            sx={{
              color: "var(--primary)",
              margin: "10px 0",
              fontSize: "18px",
              fontWeight: "600",
            }}
          >
            § 5 Commission:
          </Typography>
          <Typography>
            (1) In the first year of this Agreement, the commission payable to
            the ARTIST for all commissionable transactions (as defined in §4
            above) shall be 10% of the net revenue generated by a User for the
            COMPANY via the streaming service. In subsequent years, the
            commission rate for revenue from existing users will be adjusted to
            a rate between 1% and 5%, depending on the financial outlook of
            FAIRMUSIC for that year. However, any new users acquired by the
            ARTIST will be subject to a 10% commission rate for their first
            year. All commission payments are subject to the applicable
            statutory VAT, which shall be payable in addition.
          </Typography>
          <br />
          <Typography>
            (2) Commission payments will be calculated based on full revenues
            excluding VAT according to the respective applicable price list,
            which will be attached to this Agreement as Appendix 5.2.
          </Typography>
          <br />
          <Typography>
            (3) The commission amounts and calculation methods specified above
            can only be modified via written contractual agreements.
          </Typography>
          <br />

          <Typography
            sx={{
              color: "var(--primary)",
              margin: "10px 0",
              fontSize: "18px",
              fontWeight: "600",
            }}
          >
            § 6 Loss of entitlement to commission:
          </Typography>

          <Typography>
            (1) The entitlement to commission payments ends if – for any
            possible reason – the subscription is not valid anymore. It also
            ends if the User terminates their subscription or does not pay due
            subscription fees. <br />
            <br />
            In case of signing up through an affiliate link or using a voucher
            code users will remain locked to the selected ARTIST for Direct
            Artist Support for 12 months from the date of subscription. However,
            if the ARTIST's actions are deemed inconsistent with the values and
            principles that FAIRMUSIC upholds, the User may submit a formal
            request to have their Direct Artist Support redirected to another
            artist. Any such request will be reviewed and approved at the sole
            discretion of FAIRMUSIC.
          </Typography>
          <br />
          <Typography
            sx={{
              color: "var(--primary)",
              marginBottom: "10px",
              fontSize: "18px",
              fontWeight: "600",
            }}
          >
            § 8 ARTIST’s costs:
          </Typography>

          <Typography>
            ARTIST is not entitled to the reimbursement of costs related to the
            acquisition of users.
          </Typography>
          <br />

          <Typography
            sx={{
              color: "var(--primary)",
              margin: "10px 0",
              fontSize: "18px",
              fontWeight: "600",
            }}
          >
            § 9 Newsletter Collection and Communications:
          </Typography>
          <Typography>
            FAIRMUSIC in their ROKK Streaming App grants ARTIST the ability to
            collect email addresses in their ROKK Streaming App of users who
            expressly opt in to receive communications directly from the ARTIST
            ("Newsletter Contacts"). The ARTIST agrees that these email
            addresses will be used solely for the purpose of distributing
            newsletters and communications related to the ARTIST's musical
            career and associated content. The ARTIST further agrees to comply
            with all applicable data protection and privacy laws in the
            collection, storage, and use of such email addresses. Any misuse,
            including but not limited to reselling, sharing, or using the
            Newsletter Contacts for purposes other than the intended newsletter
            distribution, shall constitute a material breach of this Agreement
            and may result in immediate suspension or termination of the
            ARTIST’s access to this feature, at the sole discretion of ROKK.
          </Typography>
          <br />

          <Typography
            sx={{
              color: "var(--primary)",
              margin: "10px 0",
              fontSize: "18px",
              fontWeight: "600",
            }}
          >
            § 10 Contractual term:
          </Typography>
          <Typography>
            This Agreement enters into effect with its signature or with its
            conclusion via the COMPANY’s website. Its initial term is one (1)
            year. The Agreement is automatically renewed for another year unless
            terminated three (3) months in advance to the end of a term. Both
            Parties’ right to extraordinary termination in accordance with the
            relevant statutory provisions remains unaffected. In addition, the
            COMPANY has the right to terminate this Agreement for substantial
            reasons.
          </Typography>
          <br />

          <Typography
            sx={{
              color: "var(--primary)",
              margin: "10px 0",
              fontSize: "18px",
              fontWeight: "600",
            }}
          >
            § 11 Confidentiality:
          </Typography>

          <Typography>
            (1) Both Parties will treat all trade secrets, including the content
            of this Agreement as well as other information of the respective
            other Party labelled as confidential (hereinafter also referred to
            as “Confidential Information”) confidential, and both Parties accept
            the non- disclosure agreement linked during the registration
            process.
          </Typography>

          <br />
          <Typography
            sx={{
              color: "var(--primary)",
              marginBottom: "10px",
              fontSize: "18px",
              fontWeight: "600",
            }}
          >
            § 12 Applicable law, court of venue:
          </Typography>
          <Typography>
            (1) This Agreement shall be subject to the Laws of the Federal
            Republic of Germany. UN Sales Law (CISG) shall be excluded.
          </Typography>
          <br />
          <Typography>
            (2) Any and all disputes arising from or in connection with this
            Agreement (including such disputes concerning the validity of this
            Agreement) shall be brought to the courts at the COMPANY’s business
            domicile.
          </Typography>
          <br />

          <Typography
            sx={{
              color: "var(--primary)",
              margin: "10px 0",
              fontSize: "18px",
              fontWeight: "600",
            }}
          >
            § 13 Data protection:
          </Typography>
          <Typography>
            (1) Both Parties will observe all data protection related laws and
            regulations applicable to them.
          </Typography>
          <br />
          <Typography>
            (2) If and to the extent the COMPANY engages in order data
            processing (Auftragsdatenverarbeitung) concerning personal data of
            ARTIST’s employees during the performance of this Agreement, the
            Parties will enter into a corresponding data processing agreement in
            the meaning of Art. 28 DSGVO (GDPR) prior to the beginning of such
            data processing activities.
          </Typography>
          <br />

          <Typography
            sx={{
              color: "var(--primary)",
              margin: "10px 0",
              fontSize: "18px",
              fontWeight: "600",
            }}
          >
            § 14 Final provisions:
          </Typography>
          <Typography>
            (1) Any assignment of rights granted under this Agreement is subject
            to the prior written consent of the respective other Party.
          </Typography>
          <br />
          <Typography>
            (2) Any modifications or amendments to this agreement must be in
            writing in order to be effective, except for when statutory
            provisions require a stricter form. This provisions also covers
            changes to this very requirement of writing.
          </Typography>
          <br />
          <Typography>
            (3) If any of the provisions of this Agreement should be or become
            partially or entirely invalid or unenforceable, then this shall not
            affect the validity of the remaining provisions. The Parties
            undertake to replace any invalid or unenforceable provision with a
            valid and effective one matching as closely as possible the legal
            and economic purpose of the original provision in a way they would
            have done from the beginning had they realized the invalidity or
            unenforceability of the respective provision. The same holds in the
            event of gaps in this Agreement.
          </Typography>
        </InfoContainer>
      </div>
    </ContactInformationContainer>
  );
};

export default TermsOfUseArtist;
